import { ROUTE_PATH as LOCATIONS_PATH } from '@/features/locationsPage/consts';

export const createEditLocationLink = locationId =>
  `${LOCATIONS_PATH}/${locationId}/edit`;
